/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/hook-use-state */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea
} from "@repo/ui";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import Layout from "components/layout";
import {
  useEditGetExchangeJob,
  useGetExchangeDetails
} from "utils/apis/exchange-service.api";
import ExchangeServiceUpdate from "./exchange-service-update";
import ConsignmentsDetail from "components/consignmentsDetail";
import { UserContext } from "utils/reducers/user";
import {
  useGetCustomerServicePoints,
  useGetShiftRoutes
} from "utils/apis/lookups.api";
import { formatDate } from "date-fns";
import { showToast } from "utils/helper";
import { PREV_DAY_DATE } from "utils/constant";
import CollectedConsignmentsDetail from "components/collectedConsignmentsDetail";

const jobPriorities = [
  {
    id: "1",
    text: "Critical"
  },
  {
    id: "2",
    text: "High"
  },
  {
    id: "3",
    text: "Normal"
  },
  {
    id: "4",
    text: "Low"
  }
];

const jobNatures = [
  {
    id: "Normal",
    text: "Normal"
  },
  {
    id: "Adhoc",
    text: "Adhoc"
  },
  { id: "Special Service", text: "Special Service" }
];

const invoicingModels = [
  {
    id: "Fixed",
    text: "Fixed"
  },
  {
    id: "Dedicated",
    text: "Dedicated"
  },
  {
    id: "Service",
    text: "Service"
  }
];

export default function ExchangeDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = useContext(UserContext);

  const { data: request } = useGetExchangeDetails(state);
  const { data: sourceLocations } = useGetCustomerServicePoints(
    request?.customerId
  );

  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [servicePointId, setServicePointId] = useState("");
  const [ddlJobPriority, setDdlJobPriority] = useState("");
  const [ddlInvoicingModels, setDdlInvoicingModel] = useState("");
  const [ddlJobNatures, setDdlJobNatures] = useState("");
  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [serviceDateTime, setServiceDateTime] = useState(new Date());
  const [requestedBy, setRequestedBy] = useState("");
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (request) {
      setDdlJobPriority(
        jobPriorities.find((item) => item.text === request?.priority)?.id || ""
      );
      setDdlInvoicingModel(request?.invoicingModel || "");
      setDdlJobNatures(request?.jobNature || "");
      setDdlInRouteTeams(request?.routeNo || "");
      setServiceDateTime(request?.serviceDateTime?.split(" ")[0] || "");
      setRequestedBy(request?.requestedBy || "");
      setRemarks(request?.remarks || "");
    }
  }, [request]);

  const {
    mutate: editServiceJob,
    isSuccess: isEditSuccess,
    isPending: editLoading
  } = useEditGetExchangeJob();

  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      serviceDateTime ? serviceDateTime : new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    )
  });
  const childRef: any = useRef();

  let statusList: any = [];
  if (["Awaiting Packing", "Open"].includes(request?.status)) {
    statusList = [
      {
        id: "Cancelled",
        text: "Cancel"
      }
    ];
  } else if (request?.status === "Out for Delivery") {
    statusList = [
      {
        id: "Completed",
        text: "Completed"
      },
      {
        id: "Pending",
        text: "Pending"
      }
    ];
  } else if (["Completed", "Pending"].includes(request?.status)) {
    statusList = [
      {
        id: "Closed",
        text: "Close"
      }
    ];
  }

  const handleUpdateStatus = (e: any) => {
    e.stopPropagation();
    if (isEdit) setIsEdit(false);
    else setIsUpdateStatus(!isUpdateStatus);
  };

  const onSourceLocationChanged = (value: string) => {
    if (!value) {
      setServicePointId("");
      return;
    }
    setServicePointId(value);
  };

  const onEditConfirmClicked = (e: any) => {
    e.stopPropagation();
    if (!servicePointId) {
      showToast("error", "Location can not be empty.");
      return;
    }

    const editJobDto = {
      servicePointId: servicePointId || request?.servicePointId,
      requestId: request?.requestId,
      invoicingModel: ddlInvoicingModels,
      jobNature: ddlJobNatures,
      priority: parseInt(ddlJobPriority),
      serviceDateTime: formatDate(
        serviceDateTime || new Date(),
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      routeNo: ddlInRouteTeams,
      remarks,
      shift: "morning",
      requestedBy
    };
    setIsEdit(false);
    editServiceJob(editJobDto);
  };

  useEffect(() => {
    if (!state?.requestId) {
      navigate("/exchange-services");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isEditSuccess) {
      setIsEdit(false);
    }
  }, [isEditSuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/exchange-services">Exchange</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Exchange Details</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="my-5 mx-4">
        <CardContent className="p-4">
          <Accordion
            type="single"
            collapsible={!isUpdateStatus}
            defaultValue="item-1"
          >
            <AccordionItem value="item-1">
              <AccordionTrigger className="font-semibold gap-4 [&[data-state=closed]>div>button]:hidden">
                Service Detail
                <div className="flex flex-1 justify-end gap-4">
                  {!isEdit &&
                    !isUpdateStatus &&
                    !["closed", "cancelled", "completed"].includes(
                      request?.status?.toLowerCase() as string
                    ) && (
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsEdit(true);
                        }}
                        isLoading={editLoading}
                      >
                        Edit Request
                      </Button>
                    )}
                  {/* {!isUpdateStatus &&
                    !isEdit &&
                    !["closed", "cancelled"].includes(
                      request?.status?.toLowerCase() as string,
                    ) && (
                      <Button
                        variant="outline"
                        className="hide"
                        onClick={handleUpdateStatus}
                      >
                        Change Status
                      </Button>
                    )} */}
                  {isUpdateStatus || isEdit ? (
                    <>
                      <Button
                        variant="destructive"
                        className="w-[140px]"
                        type="button"
                        onClick={handleUpdateStatus}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="outline"
                        className="w-[140px]"
                        onClick={(e) =>
                          isEdit
                            ? onEditConfirmClicked(e)
                            : childRef?.current?.onBtnConfirmClicked(e)
                        }
                      >
                        Save
                      </Button>
                    </>
                  ) : null}
                </div>
              </AccordionTrigger>
              <AccordionContent>
                {request ? (
                  <>
                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Order ID:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.orderId}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Job No:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.jobNo}</span>
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Customer:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.customer}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Location:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>
                          {isEdit ? (
                            <Combobox
                              value={servicePointId || request?.sourceSPId}
                              data={sourceLocations?.map((item: any) => ({
                                label: `${item.barcode}-${item.locationId}`,
                                value: item.servicePointId
                              }))}
                              placeholder="Select Location"
                              setValue={onSourceLocationChanged}
                            />
                          ) : (
                            request?.locationName
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Location ID:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.locationId}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Location Barcode:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.barcode}</span>
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Service Type:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.serviceType}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Location Type:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.locationType}</span>
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Create Date & Time:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.createDateTime}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Service Date:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <DatePicker
                            selectedDate={serviceDateTime}
                            onSelectDate={setServiceDateTime}
                            disabled={(date) => date < PREV_DAY_DATE}
                          />
                        ) : (
                          request?.serviceDateTime?.split(" ")[0]
                        )}
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Invoicing Model:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <Select
                            onValueChange={setDdlInvoicingModel}
                            value={
                              ddlInvoicingModels || request?.invoicingModel
                            }
                          >
                            <SelectTrigger className="w-full">
                              <SelectValue placeholder="Select Invoicing Model" />
                            </SelectTrigger>
                            <SelectContent>
                              {invoicingModels.map((item) => (
                                <SelectItem key={item.id} value={item.id}>
                                  {item.text}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          request?.invoicingModel
                        )}
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          {" "}
                          Job Nature:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <Select
                            onValueChange={setDdlJobNatures}
                            value={ddlJobNatures}
                          >
                            <SelectTrigger className="w-full">
                              <SelectValue placeholder="Select Job Nature" />
                            </SelectTrigger>
                            <SelectContent>
                              {jobNatures.map((item) => (
                                <SelectItem key={item.id} value={item.id}>
                                  {item.text}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          request?.jobNature
                        )}
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Job Type:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.jobType}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Priority:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <Select
                            onValueChange={setDdlJobPriority}
                            value={ddlJobPriority}
                          >
                            <SelectTrigger className="w-full">
                              <SelectValue placeholder="Select Job Priority" />
                            </SelectTrigger>
                            <SelectContent>
                              {jobPriorities.map((item) => (
                                <SelectItem key={item.id} value={item.id}>
                                  {item.text}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          request?.priority
                        )}
                      </div>
                    </div>
                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Status:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.status}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Route No:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <Combobox
                            data={inRouteTeams?.map((m) => ({
                              value: m.routeNo,
                              label: `${m.routeNo} (${m.description})`
                            }))}
                            value={ddlInRouteTeams}
                            placeholder="Select Route"
                            setValue={setDdlInRouteTeams}
                          />
                        ) : (
                          request?.routeNo
                        )}
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Requested By:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        {isEdit ? (
                          <Input
                            type="text"
                            className="w-full"
                            value={requestedBy}
                            onChange={(e) => {
                              setRequestedBy(e.target.value);
                            }}
                          />
                        ) : (
                          request?.requestedBy
                        )}
                      </div>

                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Pending Reasons:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.pendingReason}</span>
                      </div>
                    </div>
                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Completion Date & Time:
                        </span>
                      </div>
                      <div className="w-[30%]">
                        <span>{request?.completionDateTime}</span>
                      </div>
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          Remarks:
                        </span>
                      </div>

                      <div className="w-[30%]">
                        {isEdit ? (
                          <Textarea
                            className="w-full"
                            value={remarks}
                            onChange={(e) => {
                              setRemarks(e.target.value);
                            }}
                          />
                        ) : (
                          request?.remarks
                        )}
                      </div>
                    </div>

                    <div className="border-b my-3 bg-accent" />

                    <div className="flex gap-3 px-2">
                      <div className="w-[17.5%]">
                        <span className="font-medium leading-none">
                          FieldTeam:
                        </span>
                      </div>

                      <div className="cols-10">
                        <span>{request?.fieldTeam}</span>
                      </div>
                    </div>
                  </>
                ) : null}
              </AccordionContent>
            </AccordionItem>
            {!isUpdateStatus ? (
              <>
                <AccordionItem value="item-2">
                  <AccordionTrigger className="font-semibold">
                    Packed Consignments
                  </AccordionTrigger>
                  <AccordionContent>
                    <ConsignmentsDetail
                      request={request}
                      consignments={{ containers: request?.containers || [] }}
                      type="Exchange"
                      defaultBagType="AED"
                    />
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-3">
                  <AccordionTrigger className="font-semibold">
                    Delivery Consignments
                  </AccordionTrigger>
                  <AccordionContent>
                    <ConsignmentsDetail
                      request={request}
                      consignments={request?.deliveredConsignments}
                      type="Exchange"
                      isAddConsignment={false}
                      defaultBagType="AED"
                      isShowVhr={Boolean(
                        !request?.collectedConsignments?.length ||
                          request?.collectedConsignments?.[0]?.vhrs?.[0]
                            ?.vhrNo !== request?.deliveredConsignments?.vhrNo
                      )}
                    />
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-4">
                  <AccordionTrigger className="font-semibold">
                    Collected Consignments
                  </AccordionTrigger>
                  <AccordionContent>
                    {request?.collectedConsignments?.length === 1 &&
                    request?.collectedConsignments?.[0]?.vhrs?.length === 1 ? (
                      <ConsignmentsDetail
                        request={request}
                        type="Exchange"
                        isAddConsignment={false}
                        defaultBagType="AED"
                        consignments={
                          request?.collectedConsignments?.[0]?.vhrs?.[0]
                        }
                      />
                    ) : (
                      request?.collectedConsignments?.map(
                        (collectedConsignment: any, index: number) => (
                          <CollectedConsignmentsDetail
                            count={index}
                            consignments={collectedConsignment}
                            key={collectedConsignment.vhrNo}
                            request={request}
                            type="Collection"
                          />
                        )
                      )
                    )}
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-6">
                  <AccordionTrigger className="font-semibold">
                    Logs
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex gap-3 px-2">
                      <div className="cols-12 ms-1 me-1">
                        <Grid data={request?.logs}>
                          <GridColumn field="operation" title="Action" />
                          <GridColumn
                            field="operationTime"
                            title="Date & Time"
                            width="220"
                            className="text-center"
                          />
                          <GridColumn
                            field="user"
                            title="Updated By"
                            width="320"
                          />
                          <GridColumn field="remarks" title="Remarks" />
                        </Grid>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </>
            ) : null}
          </Accordion>
          {isUpdateStatus ? (
            <ExchangeServiceUpdate
              ref={childRef}
              request={request}
              statusList={statusList}
              statusUpdated={setIsUpdateStatus}
            />
          ) : null}
        </CardContent>
      </Card>
    </Layout>
  );
}
